// src/components/FooterWrapper.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';

const FooterWrapper = () => {
  const location = useLocation();

  if (location.pathname.includes('/angebot')) {
    return null;
  }

  return <Footer />;
};

export default FooterWrapper;
